<h1 mat-dialog-title class="text-center">Copy From</h1>
<div mat-dialog-content (scroll)="onTableScroll($event)">
    <div class="entry-forms">
        <div class="tabledesign freightdetailtable">
            <app-chip [filterItems]='selectedFilters'
                (removeFilter)="onRemoveChip($event.index, $event.data)"></app-chip>
            <table mat-table [dataSource]="this.local_data">
                <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef>
                        <mat-checkbox (change)="onSelectAllChange($event)" [checked]="isAllSelected()"
                            [indeterminate]="isSomeSelected()">
                        </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let row; let i = index">

                        <mat-checkbox [(ngModel)]="row.selected" (change)="onSelectionChange(row,$event)">
                        </mat-checkbox>
                    </td>
                </ng-container>
                <ng-container matColumnDef="#">
                    <th mat-header-cell *matHeaderCellDef> # </th>
                    <td mat-cell *matCellDef="let row; let i = index"> {{i+1}} </td>
                </ng-container>

                <ng-container matColumnDef="baseDoc">
                    <th mat-header-cell *matHeaderCellDef> Base Document </th>
                    <td mat-cell *matCellDef="let row">
                        {{row.docNum}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="lineNum">
                    <th mat-header-cell *matHeaderCellDef> Line Num </th>
                    <td mat-cell *matCellDef="let row">
                        {{row.lineNum}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="itemNo">
                    <th mat-header-cell *matHeaderCellDef> Item Code
                        <i-feather class="t-icon" name="more-vertical" [matMenuTriggerFor]="menu1"></i-feather>
                        <mat-menu #menu1="matMenu" class="filtertrigger" xPosition="after">
                            <app-filter [shortColumn]="'itemCode'" [colType]="'alphabets'" [labelType]="'Item Code'"
                                [isActive]="this.active"
                                (FilterColumn)="onClickOfGenericFilterButtonForRangeString($event.column, $event.formid, $event.toid, $event.label)"
                                (sortFilter)="this.onClickOfGenericColumnSort('itemCode', this.active)"></app-filter>
                        </mat-menu>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        {{row.itemCode}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="itemDesc">
                    <th mat-header-cell *matHeaderCellDef> Item Description
                        <i-feather class="t-icon" name="more-vertical" [matMenuTriggerFor]="menu1"></i-feather>
                        <mat-menu #menu1="matMenu" class="filtertrigger" xPosition="after">
                            <app-filter [shortColumn]="'itemDescription'" [colType]="'alphabets'"
                                [labelType]="'Item Description'" [isActive]="this.active"
                                (FilterColumn)="onClickOfGenericFilterButtonForRangeString($event.column, $event.formid, $event.toid, $event.label)"
                                (sortFilter)="this.onClickOfGenericColumnSort('itemDescription', this.active)"></app-filter>
                        </mat-menu>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        {{row.itemDescription}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="qty">
                    <th mat-header-cell *matHeaderCellDef> Qty </th>
                    <td mat-cell *matCellDef="let row">
                        {{row.quantity || row.quantity}}
                    </td>

                </ng-container>
                <ng-container matColumnDef="openQuanity">
                    <th mat-header-cell *matHeaderCellDef> Open Quantity </th>
                    <td mat-cell *matCellDef="let row">
                        {{row.openQty || row.remainingOpenQuantity}}
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="this.getDisplayedColumnsNamesList;sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: this.getDisplayedColumnsNamesList;"
                    [hidden]="row.lineStatus === 'C'"></tr>
            </table>
        </div>
    </div>
</div>
<div mat-dialog-actions align="end">
    <button mat-raised-button mat-dialog-close>Cancel</button>
    <button mat-raised-button color="primary" mat-dialog-close (click)="onClose()">
        Select
    </button>
</div>